import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './index.scss';

const pickPayouts = [
  { type: 'Power', picks: 2, odds: '-137', payout: '3X' },
  { type: 'Power', picks: 3, odds: '-123', payout: '6X' },
  { type: 'Power', picks: 4, odds: '-128', payout: '10X' },
  { type: 'Flex',  picks: 4, odds: '-202', payout: '5X' },
  { type: 'Flex',  picks: 5, odds: '-171', payout: '10X' },
  { type: 'Flex',  picks: 6, odds: '-141', payout: '25X' },
];

export default function PickPayoutModal() {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        onClick={() => setShow(true)}
        className="mb-3"
        style={{
          backgroundColor: 'transparent',
          border: '2px solid #FF4A17',
          color: '#FF4A17',
          borderRadius: '6px',
          padding: '0.4rem 0.8rem',
          fontWeight: 600,
        }}
      >
        Prizepicks set payouts odds
      </Button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        centered
        dialogClassName="dark-modal"
      >
        <Modal.Header
          closeButton
          style={{ borderBottom: '1px solid #222', backgroundColor: '#0a0a0a' }}
        >
          <Modal.Title style={{ color: '#fff', fontSize: '1.1rem', fontWeight: 600 }}>
            PrizePicks Set Payout Odds
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: '#0a0a0a', padding: '1.25rem' }}>
          <div className="payout-grid">
            {pickPayouts.map(item => (
              <div
                key={`${item.type}-${item.picks}`}
                className="payout-card"
              >
                <div className="payout-card__header">
                  <span className="payout-card__picks">{item.picks} Pick</span>
                  <span className={`payout-card__type payout-card__type--${item.type.toLowerCase()}`}>
                    {item.type}
                  </span>
                </div>
                <div className="payout-card__payout">{item.payout}</div>
                <div className="payout-card__odds">
                  <span className="payout-card__odds-label">Each leg</span>
                  <span className="payout-card__odds-value">{item.odds}</span>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
